
/**
 *
 *      Data-driven UI logic for search filters
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 08/10/2017
 *      Modified on 8/16/2021 by Nhi Cmerek
 */

/**
 * Display available filters for search results
 * @param response {object} - Search API response
 */
/*global FiltersLayoutView, FilterModel, FiltersModel, FiltersView */
function displayAvailableFilters( response ) {
    var data,
        aggregations,
        names,
        type,
        k,
        filtersLayout;

    filtersLayout = new FiltersLayoutView( { el: '#available-filters' } );

    if ( response ) {
        data = response.aggregations;
        aggregations = [];
        names = [];

        for ( k in data ) {
            if ( data.hasOwnProperty( k ) && k !== "count" ) {
                aggregations.push( data[ k ].buckets );
                names.push( k );
            }
        }

        if ( response.hits && response.hits.hits ) {
            type = response.hits.hits[0] ? response.hits.hits[0]._type : null;
            if ( type ) {
                showTypeAggregations( type, aggregations, names, filtersLayout );
            } else {
                displayEmptyFilters(filtersLayout, $( '#available-filters' ), 'empty-available-filters');
            }
        }
    }
}

/**
 * Display facet / search filter in the DOM
 * @param facetName {string} - name of the facet
 * @param filtersElId {string} - DOM ID of the filters outer region
 * @param filtersLayout {object} - filters layout view
 * @param filters {object} - Backbone.Collection collection of filters
 * @param model {Backbone.Collection} - collection that represents filter fields
 */
function displayFacets( facetName, filtersElId, filtersLayout, filters, model ) {
    var label,
        el,
        type = FieldTypes.string,
        availableFilters,
        regionName,
        regionId,
        region,
        filtersModel,
        filtersView;

    if ( facetName ) {

        // add new region to the layout
        regionName = facetName.replace(".", "-");
        regionId = "#" + regionName;
        filtersLayout.addRegion(regionName, regionId);

        if ( model ) {
            label = model.get("label");
            type = model.get("type") || FieldTypes.string;
        } else {
            // fall back on the facet name if DMR does not have labels for what is in ES aggregations response
            label = facetName.split('.').join(" ");
        }

        label = label ? label.capitalizeFirstLetter() : '[Empty]';

        // add new region element to the DOM
        el = '<div class="available-field" name="' + facetName + '" id="' + regionName + '" label="' + label + '" type="' + type + '"></div>';
        availableFilters = $(filtersElId);
        availableFilters.append(el);

        // render filters collection inside the region
        filtersModel = new FiltersModel();
        filtersModel.set("name", facetName);
        // store field original name in the element's attribute
        filtersModel.set("originalName", facetName);

        filtersModel.set( "label", label.capitalizeFirstLetter() );
        filtersModel.set( "type", type );

        filtersView = new FiltersView( { collection: filters, model: filtersModel } );
        region = filtersLayout.getRegion( regionName );
        if ( region ) {
            region.show( filtersView );
        }
    }
}

/**
 * Display show more/show less links for a collection and hide the rest
 * @param alwaysShown {number} - the number of items that are always shown
 * @param el {object} - the parent element to show/hide
 * @param showMore {object} - the link element that displays all children
 * @param showLess {object} - the link element that hides all but always visible children
 */
function showMoreLess(alwaysShown, el, showMore, showLess) {
    var size = el.length,
        i;
    // show only the top n items, where n is the number alwaysShown
    showLess.hide();
    showMore.show();
    if (size <= alwaysShown) {
        showMore.hide();
    } else {
        for (i = alwaysShown; i < size; ++i) {
            $(el[i]).hide();
        }
    }
    // show more expands the list and shows all available facets
    showMore.click(function (e) {
        e.stopPropagation();
        for (i = alwaysShown; i < size; ++i) {
            $(el[i]).show();
        }
        showMore.hide();
        showLess.show();
        setFooter();
    });

    // hide all but the top number of facets that are always visible
    showLess.click(function (e) {
        e.stopPropagation();
        for (i = alwaysShown; i < size; ++i) {
            $(el[i]).hide();
        }
        showMore.show();
        showLess.hide();
        setFooter();
    });
    setFooter();

}

/***
 * Set and display current filters in the form "field" : "value", e.g. "Type : Hazard"
 * If multi-faceted search flag is true, display non-type filters only
 */
function displayCurrentFilters() {

    var filtersLayout,
        currentFiltersEl,
        currentFilters,
        model,
        field,
        type;

    if ( App && App.globalState ) {

        filtersLayout = App.globalState.filtersLayout;

        if ( filtersLayout ) {
            currentFiltersEl = $( '#current-filters' );
            filtersLayout.render();

            if ( currentFiltersEl ) {
                currentFiltersEl.show();

                currentFilters = App.globalState.currentFilters;

                if ( currentFilters && currentFilters.length > 0 ) {

                    field = currentFilters.models[ 0 ].get( "field" );
                    if ( field === "type" ) {
                        type =  currentFilters.models[ 0 ].get( "value" );
                        model = getDataModel( type, false );
                        if ( ! model ) {
                            fetchModelForCurrentFilters( type, filtersLayout, currentFiltersEl );
                        } else {
                            showCurrentFilters( model, filtersLayout, currentFiltersEl );
                        }
                    } else if ( field === "indexed" ) {
                        // show date filter
                        showCurrentFilters( null, filtersLayout, currentFiltersEl );
                    }
                }
            }
        }
    }
}

/**
 * Display all but type filters in the current filters panel
 */
function displayCurrentNonTypeFilters() {
    var filtersLayout,
        currentFiltersEl,
        currentFilters,
        field,
        filterModel,
        i;

    if ( App && App.globalState ) {

        filtersLayout = App.globalState.filtersLayout;

        if ( filtersLayout ) {
            currentFiltersEl = $( '#current-filters' );
            filtersLayout.render();

            if ( currentFiltersEl ) {
                currentFiltersEl.show();

                currentFilters = App.globalState.currentFilters;

                if ( currentFilters && currentFilters.length > 0 ) {

                    for ( i = 0; i < currentFilters.length; i++ ) {
                        filterModel = currentFilters.models[ i ];
                        if ( filterModel ) {
                            id = addCurrentFilterRegion( filterModel, i, filtersLayout, currentFiltersEl );
                            field = currentFilters.models[ i ].get( "field" );
                            if ( field !== "type" ) {
                                displayCurrentFilter( filterModel, id, new BackboneModel, filtersLayout );
                            }
                        }
                    }
                }
            }
        }
    }
}
/**
 * Call DMR to get the UI model for the specified type
 * @param type {string} - data type name
 * @param filtersLayout {object} - Backbone layout view for search filters
 * @param currentFiltersEl {object} - DOM element where current filters are rendered
 */
function fetchModelForCurrentFilters( type, filtersLayout, currentFiltersEl ) {

    var model;
    if ( type && GlobalPageState && GlobalPageState.models ) {
        model = GlobalPageState.models[ type ];

        // if model has not been fetched yet, retrieve it from DMR and call a display callback
        if ( ! model ) {
            // success callback displays current filters using server model
            // if the call to DMR fails, display an error view
            getJSONUIModel( type, displayDMRCurrentFilters( type, filtersLayout, currentFiltersEl ), dataNotFound( "Get JSON UI model for " + type ) );
        }

    }
}

/**
 * Callback function that displays current filters
 * @param type {string} - data type name
 * @param filtersLayout {object} - Backbone layout view for search filters
 * @param currentFiltersEl {object} - DOM element where current filters are rendered
 * @returns {Function}
 */
function displayDMRCurrentFilters( type, filtersLayout, currentFiltersEl ) {

    /**
     * Callback that is called when the call to fetch the model from Data Model Registry succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {
        var model = data;
        if ( model ) {

            // save the server model into global state variable
            saveDataModel( type, model );
            showCurrentFilters( model, filtersLayout, currentFiltersEl );
        }
    };
}

/**
 * Display current filters based on UI model that exists
 * @param dataModel {null|object} - JSON UI data model
 * @param filtersLayout {object} - Backbone layout view for search filters
 * @param currentFiltersEl {object} - DOM element where current filters are rendered
 */
function showCurrentFilters( dataModel, filtersLayout, currentFiltersEl ) {

    var currentFilters,
        filterModel,
        id,
        emptyId,
        i;


    if ( App.globalState && App.globalState.currentFilters && filtersLayout ) {

        currentFilters = App.globalState.currentFilters;
        if ( currentFilters && currentFilters.length > 0 ) {

            for ( i = 0; i < currentFilters.length; i++ ) {
                filterModel = currentFilters.models[ i ];
                if ( filterModel ) {
                    id = addCurrentFilterRegion( filterModel, i, filtersLayout, currentFiltersEl );
                    displayCurrentFilter( filterModel, id, dataModel, filtersLayout );
                }
            }
        } else {
            // Display an empty filters layout
            emptyId = "empty-current-filters";
            displayEmptyFilters( filtersLayout, currentFiltersEl, emptyId );
        }
    }

}

/**
 * Display a message that no filters were found
 * @param filtersLayout {object} - Backbone layout view of the filters
 * @param filtersEl {object} - filters outer DOM element
 * @param id {string} - unique id of the message element
 */
function displayEmptyFilters( filtersLayout, filtersEl, id ) {
    var model,
        filterView;


    if ( filtersLayout && filtersEl && id ) {

        // Check if region already exists in the DOM and layout
        checkLayoutView( id, filtersEl, filtersLayout );

        // Show the region with message
        model = new BackboneModel;
        model.set( "message", "No filters found" );
        filterView = new EmptyFiltersView( { model: model } );

        // Show the view in its region
        showLayoutView( id, filterView, filtersLayout );

        // Hide Refine types button if there are no available filters
        if ( $('#refine-types-button')  ) {
            $('#refine-types-button').hide();
        }

        // Hide show more button
        $('#showMore').hide();
    }
}

/**
 * Create and add a new region for a filter in current filters layout
 * Create a new DOM element to render the region into
 * @param filter {BackboneModel} - filter model to display
 * @param index {number} - index of the filter in the current filters array
 * @param filtersLayout {object} - Backbone layout view for search filters
 * @param currentFiltersEl {object} - DOM element where current filters are rendered
 * @returns {*}
 */
function addCurrentFilterRegion( filter, index, filtersLayout, currentFiltersEl ) {
    var field,
        modifiedName,
        id,
        el,
        regionName;

    if ( filter && filtersLayout && currentFiltersEl ) {
        field = filter.get( "field" );
        if ( field  ) {
            modifiedName = field.replace( /\./g, '_' );
            // To ensure that id is unique, add an index of the filter
            id = modifiedName + "-" + index;
            el = '<div class="current-field" name="' + field + '" id="' + id + '"></div>';

            // check if region already exists in the DOM
            if ( $('#' + id ).length === 0 ) {
                currentFiltersEl.append( el );
            }

            // check if region already exists in the layout
            if ( filtersLayout && filtersLayout.getRegion( id ) === undefined ) {
                regionName = "#" + id;
                filtersLayout.addRegion( id, regionName );
            }
        }
    }
    return id;
}

/**
 * Display one filter in the region for current filters
 * @param filterModel {BackboneModel} - filter model to display
 * @param id {string} - filter region id
 * @param dataModel {object} - JSON UI data model
 * @param filtersLayout {object} - Backbone layout view for search filters
 */
function displayCurrentFilter( filterModel, id, dataModel, filtersLayout ) {

    var filterField,
        filterDisplayValue,
        dataTypeName,
        dataTypeLabel,
        filterView,
        currentView,
        currentModel,
        filterRegion;

    var multifaceted = App.globalState.multifacets; // global multi-faceted flag

    if ( filterModel ) {

        filterField = filterModel.get( "field" );
        filterDisplayValue = filterModel.get( "displayValue" );

        // User the data model to get filter display value if it doesn't exist
        if ( filterField === "type" ) {
            // check that filter has a display value
            if ( ! filterDisplayValue ) {
                // Get the data model type, label and display value from its top-level "name" property
                dataTypeName = getModelProperty( dataModel, "name" );
                dataTypeLabel = getModelProperty( dataModel, "label" );

                if ( filterModel.get( "value" ) === dataTypeName ) {
                    filterModel.set( "displayValue", dataTypeLabel );
                }
            }
        } else {
            // Check all other filters
            filterModel = updateFilterModel( filterModel, dataModel );
        }
    }
    
    filterView = new CurrentFilterView( { model: filterModel } );
    if ( id && filtersLayout ) {

        // check if this region has already been shown
        filterRegion = filtersLayout.getRegion( id );

        // Don't show type filter in the current filters layout if multi-faceted flag is true
        if ( filterRegion && ( ! multifaceted || filterField !== "type" )) {
            currentView = filterRegion.currentView;

            if ( ! currentView ) {
                filterRegion.show( filterView );
            } else {
                currentModel = currentView.model;
                if ( currentModel !== filterModel ) {
                    filterRegion.show( filterView );
                }
            }
        }
    }
}

/**
 * Update filter model with display value
 * @param filterModel {BackboneModel} - filter model to display
 * @param dataModel {object} - JSON UI data model
 * @returns {BackboneModel}
 */
function updateFilterModel( filterModel, dataModel ) {

    var filterField,
        recordCollection,
        filterValue,
        dataFieldModel,
        filterLabel,
        filterType,
        displayValue;

    if ( filterModel ) {

        filterField = filterModel.get("field");

        // Convert data model properties array (top-level) properties into a Backbone collection
        recordCollection = convertDataModelPropertiesToCollection( dataModel );
        if ( recordCollection ) {
            if (filterField && filterField.indexOf(".") > -1) {
                dataFieldModel = getNestedFieldModel(filterField, recordCollection);
            } else {
                dataFieldModel = recordCollection.findWhere({name: filterField});
            }
        }

        // check the filter model for the label
        // if it doesn't exist get it from the data model

        filterLabel = filterModel.get( "label" );
        if ( ! filterLabel && dataFieldModel ) {
            filterLabel = dataFieldModel.get( "label" );
        }

        // Set filter label to capitalized field name as default
        // if label doesn't exist in the filter model or the data model
        if ( ! filterLabel && filterField ) {
            filterLabel = filterField.capitalizeFirstLetter();
        }
        filterModel.set( "label", filterLabel );

        // check the value of the filter
        filterValue = filterModel.get( "value" );

        // Special display for empty values
        if ( filterValue === "" ) {
            displayValue = getDisplayForEmptyFilter( filterModel );
        }

        // check the type of the filter
        filterType = filterModel.get( "type" );

        if ( filterField === "indexed" && ! filterType ) {
            filterType = "date";
        } else if ( ! filterType ) {
            filterType = typeof filterValue;
        }

        // Special display for dates and enumerations
        // Enumeration
        if ( filterType === "enumeration" ) {
            displayValue = getDisplayValueForEnumeration( filterModel, dataFieldModel );
        }
        // Date
        if ( filterType === "date" ) {
            displayValue = getDisplayValueForDate( filterModel );
        }

        filterModel.set( "displayValue", displayValue );
    }

    return filterModel;
}

/**
 * Get nested field data field model
 * @param filterField {string} - name of the field
 * @param recordCollection {object} - Backbone collection of record data model
 * @return {*}
 */
function getNestedFieldModel( filterField, recordCollection ) {
    var dataFieldModel,
        compoundName,
        parentName,
        fieldName,
        parentFieldModel,
        parentCollection;

    if ( filterField && recordCollection ) {
        compoundName = filterField.split(".");
        if ( compoundName && compoundName.length === 2 ) {
            parentName = compoundName[0];
            fieldName = compoundName[1];

            parentFieldModel = recordCollection.findWhere( { name: parentName } );

            // Convert properties array into a Backbone collection
            if ( parentFieldModel ) {
                parentCollection = getBackboneCollection( parentFieldModel.get( "properties" ) );

                // Find child model inside the parent properties array
                if ( parentCollection ) {
                    dataFieldModel = parentCollection.findWhere( { name: fieldName  } );
                }
            }
        }
    }
    return dataFieldModel;
}

/**
 * Get the display value for enumeration type filter
 * @param filterModel {BackboneModel} - filter model to display
 * @param model {object} - JSON UI data model
 * @returns {*}
 */
function getDisplayValueForEnumeration( filterModel, model ) {

    var displayValue,
        value,
        valueLabels;

    if ( filterModel && model ) {
        value = filterModel.get( "value" );
        // Check if options object exist in the data model for that field value
        valueLabels = model.get( "options" ) || model.get( "valueLabels" );
        if ( valueLabels ) {
            displayValue = valueLabels[ value ];
        }
        if ( ! displayValue ) {
            displayValue = value;
        }
    }
    return displayValue;
}

/**
 * Get the display value for filters with empty value
 * @param filterModel {BackboneModel} - filter model to display
 * @returns {string}
 */
function getDisplayForEmptyFilter( filterModel ) {

    var displayValue,
        predicateModel,
        isEmpty;

    displayValue = '[ Empty ]';

    if ( filterModel ) {
        // display [is empty], [isn't empty] as a value for current filter with that predicate
        predicateModel = App.globalState.fieldPredicates.findWhere( { url: filterModel.get( "operator" ) } );
        if ( predicateModel ) {
            isEmpty = predicateModel.get( "value" ) === Predicates.isEmpty || predicateModel.get( "value" ) === Predicates.notEmpty;
            if ( isEmpty ) {
                displayValue = '[ ' + predicateModel.get( "label" ) + ' ]';
            }
        }
    }
    return displayValue;
}

/**
 * Add a new filter to the filters global variable
 * @param field {string} - field name
 * @param label {string} - field display name
 * @param value {*} - field value
 * @param displayValue {string} - field display value
 * @param operator {string} - one of FieldPredicates
 * @param type {string} - type of the filter, one of the FieldTypes
 */
function addFilterToGlobal( field, label, value, displayValue, operator, type ) {

    var model,
        filter,
        add,
        uniqueArray,
        i;

    // check if filter exists in the global filters array
    add = true;
    if ( App && App.globalState && App.globalState.currentFilters && App.globalState.currentFilters.models ) {
        for ( i = 0; i < App.globalState.currentFilters.models.length; i++ ) {
            model = App.globalState.currentFilters.models[ i ];
            if ( model && model.get("field") === field && model.get("label") === label && model.get("value") === value && model.get("operator") === operator ) {
                add = false;
            }
        }

        if ( add ) {

            filter = new FilterModel();
            filter.set("field", field);
            filter.set("label", label);
            filter.set("value", value);
            filter.set("displayValue", displayValue);
            filter.set("operator", operator);
            filter.set("type", type);

            App.globalState.currentFilters.add( filter );

            uniqueArray = getUniqueFilters();
            App.globalState.currentFilters.reset(null);
            App.globalState.currentFilters.set( uniqueArray );

        }
    }
}

/**
 * Remove all type filters from global filters
 */
function removeAllTypeFilters() {

    var model,
        i,
        modelIds = [];

    if ( App && App.globalState && App.globalState.currentFilters && App.globalState.currentFilters.models ) {
        for ( i = 0; i < App.globalState.currentFilters.models.length; i++ ) {

            model = App.globalState.currentFilters.models[i];


            if ( model && model.get("field") === "type" ) {
                modelIds.push( model.cid );
            }
        }

        if ( modelIds.length > 0 ) {
            App.globalState.currentFilters.remove( modelIds );
        }
    }
}

/***
 * Hide or show border around search filters
 * @param availableFiltersEl {string} - DOM element
 */
function setFiltersBorder( availableFiltersEl ) {
    var availableFilters;
    if ( availableFiltersEl ) {
        availableFilters = $( availableFiltersEl );
        if ( availableFilters ) {
            if (  availableFilters.children() && availableFilters.children().length === 0 ) {
                availableFilters.css( 'border-top', 'none' );
            } else {
                availableFilters.css( 'border-top', 'initial' );
            }
        }
    }
}

/**
 * Add filter from available filters menu to global filters collection and update URL
 * @param field {string} - filter field name
 * @param label {string} - filter field label (display name)
 * @param value {*} - filter value
 * @param displayValue {string} - filter display value
 * @param operator {string} - filter field operator, "eq" or "gt"
 * @param type {string} - filter type, one of FieldTypes
 */
function addFilter( field, label, value, displayValue, operator, type ) {
    var filter,
        add = true;


    if ( field === "types" ) {
        field = "type";
    }

    filter = new FilterModel();
    filter.set( "field", field );
    filter.set( "label", label );
    filter.set( "value", value );
    filter.set( "displayValue", displayValue );
    filter.set( "operator", operator );
    filter.set( "type", type );

    if ( App && App.globalState && App.globalState.currentFilters ) {
        _.each( App.globalState.currentFilters.models, function ( filter ) {
            if ( filter.get( "field" ) === field && filter.get( "value" ) === value ) {
                add = false;
            }
        });

        if ( add ) {

            App.globalState.currentFilters.add( filter );

            updateURLFromFilters( true );
        }
    }
}

/**
 * Remove search filter from global filters collection and update URL
 * @param field {string} - filter field name
 * @param value {string} - filter field value
 * @param trigger {boolean} - signal to trigger redirect
 */
function removeFilter( field, value, trigger ) {
    var filters = [],
        indexed = false,
        indexedFilter = new FilterModel();

    // check if indexed filter is selected
    if ( App.globalState.dateFilter !== DateFilterKeys.all ) {
        _.each( App.globalState.currentFilters.models, function ( filter ) {
            if ( filter.get("field") === "indexed" ) {
                indexed = true;
                indexedFilter.set( "field", filter.get( "field" ));
                indexedFilter.set( "label", filter.get( "label" ));
                indexedFilter.set( "value", filter.get( "value" ));
                indexedFilter.set( "displayValue", filter.get( "displayValue" ) );
                indexedFilter.set( "operator", filter.get( "operator" ) );
                indexedFilter.set( "type", "date" );
            }
        });
    }

    if ( field === "type" ) {

        // remove all filters except indexed
        App.globalState.currentFilters.reset( null );
        if ( indexed ) {
            addFilterToGlobal( indexedFilter.get( "field" ), indexedFilter.get( "label" ), indexedFilter.get( "value" ), indexedFilter.get( "displayValue" ), indexedFilter.get( "operator" ), FieldTypes.date );
        }
    }
    else {

        _.each( App.globalState.currentFilters.models, function ( filter ) {
            if ( filter.get( "field" ) === field && filter.get( "value" ) === value ) {
                filters.push( filter );
            }
        });

        App.globalState.currentFilters.remove( filters );

    }

    if ( field === "indexed" ) {
        App.globalState.dateFilter = DateFilterKeys.all;
        $( '#date-filter' ).val( App.globalState.dateFilter );
    }

    updateURLFromFilters( trigger );

}

/***
 * Returns the href attribute for available filters including the first slash, e.g. "/search/query?type=<DataType>
 * Returns false if filter is undefined
 * @param filter {object} - HTML link element
 */
function getFilterRef( filter ) {
    var parent,
        field,
        value,
        type,
        current,
        urlArray,
        query,
        q,
        base,
        collection,
        add,
        i,
        globalFilter,
        filterModel,
        result = false;

    if ( filter ) {
        value = $( filter )[0].name;
        parent = $( filter ).parents( '.available-field' )[ 0 ];
        field = parent.name;
        type = $( filter ).parents( '.available-field' )[ 0 ].type;

        if ( field === "types" ) {
            field = "type";
        }

        // Create href attr with selected filter
        current = Backbone.history.getFragment();
        urlArray = current.split( '?' );
        query = urlArray[ 0 ];
        base = query.split( "/" )[ 0 ];

        if ( base === "hst" ) {
            base = query;
            query = "";
        } else {
            q = query.split( "/" )[ 1 ];
            query = q ? decodeURIComponent( q ) : "";
        }

        // copy the global filters collection so that it points to a different object
        collection = new FilterCollection();
        add = true;
        for ( i = 0; i < App.globalState.currentFilters.length; i++ ) {
            globalFilter = App.globalState.currentFilters.models[ i ];
            collection.add( globalFilter );
            if ( field && globalFilter.get( "field" ).toLowerCase() === field.toLowerCase() && globalFilter.get( "value" ).toLowerCase() === value.toLowerCase() ) {
                add = false;
            }
        }
        if ( add ) {
            filterModel = new FilterModel();
            filterModel.set( "field", field );
            filterModel.set( "label", field );
            filterModel.set( "value", value );
            filterModel.set( "operator", "eq" );
            filterModel.set( "type", type || "string" );

            collection.add( filterModel );
        }

        result = '/' + getRouteFromVariables( base, query, collection );
    }
    return result;
}

/**
 * Add new DMR data type filter or label to the filters array
 * @param field {string} - filter name
 * @param label {string} - filter label
 * @param value {null|number} - number of records or null if it's a category label
 * @param filters {Backbone.Collection} - collection of filters
 * @param isLabel {boolean} - true if it is a category label
 * @returns {*}
 */
function pushFilterToCategoryArray( field, label, value, filters, isLabel ) {

    var filter;
    if ( filters ) {

        filter = new FilterModel;
        filter.set( "field", field );
        if ( value ) {
            filter.set( "value", numberWithCommas( value ) );
        } else {
            filter.set( "value", '' );
        }
        if ( label ) {
            filter.set( "label", label );
            filter.set( "displayValue", label );
        }

        if ( isLabel ) {
            filter.set( "isLabel", true );
        } else {
            filter.set( "isTypeFilter", true );
        }

        filters.add( filter );
    }

    return filters;
}

/**
 * Style how filters are rendered: select checked types
 * @param nTypes {number} - number of filters to show
 * @param filtersElId {string} - filters parent DOM element id
 */
function styleFiltersLayout( nTypes, filtersElId ) {

    setFiltersBorder( filtersElId );
    showMoreLess( nTypes, $( '#available-filters > .available-field' ), $( '#showMore' ), $( '#showLess' ) );
    hideSearchLoadingIcon( 'facets-loading-icon' );
    setFooter();

    // Check if multi-faceted search flag is true
    if ( App && App.globalState && App.globalState.multifacets ) {
        // Show selected types
        showSelectedTypes();
    }

    // Check if there are two types filters
    // Hide the "types" one that does not have the DMR model labels
    if ( $('#type')  && $('#types') ) {
        $('#types').hide();
    }
}

/**
 * Get filters and type parameters from a collection of filters
 * @param args {object} - ES Ajax request object
 * @param collection {Backbone.Collection} - filters collection
 * @returns {object}
 */
function getFiltersString( args, collection ) {

    var filter,
        field,
        operator,
        type,
        values,
        dates,
        filtersRoute = '',
        i;


    if ( collection && args ) {
        for ( i = 0; i < collection.length; i++ ) {
            filter = collection.models[ i ];

            if ( filter.get( "field" ) === "type" ) {

                // Check if there's an existing type already
                if ( ! args.type ) {
                    args.type = filter.get( "value" );
                } else {
                    // Add types to the type argument
                    args.type += "," + filter.get( "value" );
                }
            }
            else {
                // Check that filter is valid
                if ( filter ) {
                    field = filter.get( "field" );
                    operator = filter.get( "operator" );
                    type = filter.get( "type" );
                    if ( ! type ) {
                        type = "string";
                    }
                    if ( field && operator && type ) {
                        if ( type === "date" && operator.toLowerCase() === Predicates.between.toLowerCase() ) {
                            values = decodeURIComponent( filter.get("value") );
                            if ( values ) {
                                dates = values.split(',');
                                if ( dates && dates.length === 2 ) {
                                    filtersRoute += field + '|' + operator + "|" + dates[ 0 ]   + ',' + dates[ 1 ] + ";";
                                }
                            }
                        }
                        else {
                            filtersRoute += field + '|' + operator + "|" + filter.get( "value" )  + ";";
                        }
                    }
                }
            }
        }

        if ( filtersRoute ) {
            args.filters = filtersRoute;
        }
    }
    return args;
}


/**
 * Set global filters collection based on the Search API response
 * @param response {object} - Search API response
 */
function setGlobalFilters( response ) {

    var current = Backbone.history.getFragment(),
        queryFilters = current.split('?'),
        currentFilters,
        urlArray;

    if ( queryFilters.length > 1 ) {
        setAliasFromURL();
        setQueryFromURL();

        urlArray =  queryFilters[ 1 ].split( '&' ) ? queryFilters[ 1 ].split('&') : [];

        if ( App && App.globalState && App.globalState.currentFilters ) {
            currentFilters = App.globalState.currentFilters;
            if ( urlArray.length > 0 && currentFilters.length === 0 ) {
                addURLFilters( urlArray, response );
            }
        }
    }
}

/**
 * Compare URL filters with globally defined filters and match global filters with the URL filters
 * @param urlFiltersArray {Array} - array of strings from filters URL parameter
 * @param currentFilters {object} - Backbone collection of global filter models
 */
function checkGlobalFilters( urlFiltersArray, currentFilters ) {

    var fieldNames,
        fieldValues,
        fieldPredicates,
        urlFilter,
        urlFilterArray,
        urlField,
        urlPredicate,
        urlValue,
        j;


    fieldNames = [];
    fieldValues = [];
    fieldPredicates = [];

    if ( urlFiltersArray ) {
        for ( j = 0; j < urlFiltersArray.length; j++ ) {
            urlFilter = urlFiltersArray[j];
            if ( urlFilter ) {

                urlFilterArray = urlFilter.split("|");

                if ( urlFilterArray && urlFilterArray.length === 3 ) {
                    urlField = urlFilterArray[0];
                    urlPredicate = urlFilterArray[1];
                    urlValue = urlFilterArray[2];

                    if ( urlField && urlPredicate && urlValue ) {
                        fieldNames.push( urlField );
                        fieldPredicates.push( urlPredicate );
                        fieldValues.push( urlValue );
                    }
                }
            }
        }
    }



    // Check the field names and values of URL filters and the global filters
    addFiltersToMatchURL( fieldNames, fieldValues, fieldPredicates );

    // remove filters from global store that do not match the URL string
    removeFiltersToMatchURL( fieldNames, fieldValues, fieldPredicates );
}

/**
 * Add filters to the global store to match the filters in the URL
 * @param fieldNames {Array} - array of field names
 * @param fieldValues {Array} - array of field values
 * @param fieldPredicates {Array} - array of field predicates
 */
function addFiltersToMatchURL( fieldNames, fieldValues, fieldPredicates ) {
    var add = [],
        k,
        modelFound,
        newModel,
        currentFilters = App.globalState.currentFilters;

    for ( k = 0; k < fieldNames.length; k++ ) {

        modelFound = false;
        _.each( currentFilters.models, function( model ) {
            if ( fieldNames[k] === model.get("field") && fieldValues[k] === model.get("value") && fieldPredicates[k] === model.get("operator")) {
                modelFound = true;
            }
        });

        if ( ! modelFound && fieldNames[k] !== "type" ) {
            newModel = new BackboneModel();
            newModel.set("field", fieldNames[k]);
            newModel.set("value", fieldValues[k]);
            newModel.set("operator", fieldPredicates[k]);
            add.push( newModel );
        }
    }
    currentFilters.add( add );
}

/**
 * Remove filters from the global store to match the filters in the URL
 * @param fieldNames {Array} - array of field names
 * @param fieldValues {Array} - array of field values
 * @param fieldPredicates {Array} - array of field predicates
 */
function removeFiltersToMatchURL( fieldNames, fieldValues, fieldPredicates ) {
    var remove = [],
        modelFound,
        k,
        currentFilters = App.globalState.currentFilters;

    _.each( currentFilters.models, function( model ) {
        modelFound = false;
        for ( k = 0; k < fieldNames.length; k++ ) {
            if ( fieldNames[k] === model.get("field") && fieldValues[k] === model.get("value") && fieldPredicates[k] === model.get("operator")) {
                modelFound = true;
            }
        }
        if ( ! modelFound && model.get("field") !== "type" ) {
            remove.push( model );
        }
    });
    currentFilters.remove( remove );
}